import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

import { Division } from './types'

export const fetchDivisionList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: { userDivisionID: string } }) => {
  return wretchClient
    .url('/admin/1.0/division/user-divisions')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<{ userDivisions: Division[] }>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}

export const saveAddUpdateDivision = async (params?: { abortCtrl?: AbortController | AbortSignal, value?: any[] }) => {
  return wretchClient
    .url('/admin/1.0/division/save')
    .signal(params?.abortCtrl)
    .post(params?.value)
    .json<{ divisionPL: Division[] }>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}
